<div class="main-popup mt-4">
    <div class="main-title-popup mb-4">
        <h1>Medication Program</h1>
        <p>Details for medication program</p>
    </div>
    <form [formGroup]="medicationForm" (ngSubmit)="save()">
        <div formArrayName="medications">
            <div
                class="add-ave-medication"
                *ngFor="let medication of medications.controls; let i = index"
                [formGroupName]="i"
            >
                <div class="row">
                    <!-- <div class="col-md-12">
                        <span class="average-weight-remove" (click)="removeMedication(i)"><i
                                class="fas fa-times-circle"></i></span>
                    </div> -->
                    <!-- Brand Dropdown -->
                    <div class="col-md-3 formGroup mb-3">
                        <label
                            >Brand<span class="text-danger-required"
                                >*</span
                            ></label
                        >
                        <select formControlName="brandId" class="form-control">
                            <option value="" disabled selected>Select</option>
                            <option
                                *ngFor="let brand of brandOptions"
                                [value]="brand.id"
                            >
                                {{ brand.name }}
                            </option>
                        </select>
                        <div
                            *ngIf="
                                medication.get('brandId').invalid &&
                                medication.get('brandId').touched
                            "
                            class="text-danger"
                        >
                            Please Select brand.
                        </div>
                    </div>

                    <!-- Type Dropdown -->
                    <div class="col-md-3 formGroup mb-3">
                        <label
                            >Application Type<span class="text-danger-required"
                                >*</span
                            ></label
                        >
                        <select formControlName="typeId" class="form-control">
                            <option value="" disabled selected>Select</option>
                            <option
                                *ngFor="let type of typeOptions"
                                [value]="type.id"
                            >
                                {{ type.name }}
                            </option>
                        </select>
                        <div
                            *ngIf="
                                medication.get('typeId').invalid &&
                                medication.get('typeId').touched
                            "
                            class="text-danger"
                        >
                            Please Select Application Type.
                        </div>
                    </div>

                    <!-- Classification Dropdown -->
                    <div class="col-md-3 formGroup mb-3">
                        <label
                            >Classification<span class="text-danger-required"
                                >*</span
                            ></label
                        >
                        <select
                            formControlName="classiFicationId"
                            class="form-control"
                        >
                            <option value="" disabled selected>Select</option>
                            <option
                                *ngFor="
                                    let classification of classificationOptions
                                "
                                [value]="classification.id"
                            >
                                {{ classification.name }}
                            </option>
                        </select>
                        <div
                            *ngIf="
                                medication.get('classiFicationId').invalid &&
                                medication.get('classiFicationId').touched
                            "
                            class="text-danger"
                        >
                            Please Select Classification.
                        </div>
                    </div>
                    <!-- Dose Input -->
                    <div class="col-md-3 formGroup mb-3">
                        <label
                            >Quantity (Box)<span class="text-danger-required"
                                >*</span
                            ></label
                        >
                        <!-- <select formControlName="dose" class="form-control">
                            <option value="" disabled selected>Select Dose</option>
                            <option *ngFor="let dose of doses" [value]="dose.id">{{ dose.name }}</option>
                        </select> -->
                        <input
                            type="number"
                            formControlName="dose"
                            class="form-control"
                        />
                        <div
                            *ngIf="
                                medication.get('dose').invalid &&
                                medication.get('dose').touched
                            "
                            class="text-danger"
                        >
                            Please Select Dose.
                        </div>
                        <span
                            class="text-danger"
                            *ngIf="medication.get('dose').errors?.min"
                            >Value must be non-negative.</span
                        >
                    </div>                
                    
                </div>

                   <!-- House Medication Section -->
                    <div class="house-selection-section mt-4">

                            <!-- House Multi Select -->
                        <div class="row mt-3">

                            <div class="col-md-12 formGroup p-multiSelect-custom">

                                <label>
                                    Select Houses
                                    <span class="text-danger-required">*</span>
                                </label>

                                <p-multiSelect
                                    formControlName="houseIds"
                                    [options]="houses"
                                    optionLabel="houseName"
                                    optionValue="houseId"
                                    [placeholder]="'Select Houses'"
                                    [showToggleAll]="false"
                                    [filter]="true"
                                    panelStyleClass="hide-close-btn"
                                    (onChange)="onHouseSelectionChange($event, i)"
                                >
                                </p-multiSelect>

                                <div
                                    *ngIf="
                                        medication.get('houseIds')?.invalid &&
                                        medication.get('houseIds')?.touched
                                    "
                                    class="text-danger mt-1"
                                >
                                    Please select at least one house.
                                </div>

                            </div>

                        </div>

                        <!-- Selected House Medication Rows -->
                        <div
                            formArrayName="houseMedications"
                        
                        >

                            <div
                                *ngIf="getHouseMedications(i).controls.length > 0"
                                class="selected-house-title mb-3"
                            >
                            </div>

                            <div
                                *ngFor="
                                    let house of getHouseMedications(i).controls;
                                    let j = index
                                "
                                [formGroupName]="j"
                                class="selected-house-card row align-items-center mb-3"
                            >

                                <!-- House Name -->
                                <div class="col-md-6 formGroup">

                                    <label>
                                        House Name
                                    </label>

                                    <input
                                        type="text"
                                        class="form-control house-readonly-input"
                                        formControlName="houseName"
                                        readonly
                                    />

                                </div>

                                <!-- Birds Medicated -->
                                <div class="col-md-6 formGroup">

                                    <label>
                                        Birds Medicated
                                    </label>

                                    <input
                                        type="number"
                                        class="form-control"
                                        formControlName="medicatedBirds"
                                        placeholder="Enter medicated birds"
                                    />

                                </div>

                            </div>

                        </div>

                    </div>
                    
                <div class="row">
                    <!-- Duration Input -->
                    <div class="col-md-3 formGroup mb-3">
                        <label
                            >Duration (days)<span class="text-danger-required"
                                >*</span
                            ></label
                        >
                        <input
                            type="number"
                            formControlName="duration"
                            class="form-control"
                            min="0"
                        />
                        <div
                            *ngIf="
                                medication.get('duration').invalid &&
                                medication.get('duration').touched
                            "
                            class="text-danger"
                        >
                            Please enter duration.
                        </div>
                        <span
                            class="text-danger"
                            *ngIf="medication.get('duration').errors?.min"
                            >Value must be non-negative.</span
                        >
                    </div>

                    <div class="col-md-3 formGroup mb-3">
                        <label
                            >Application Date<span class="text-danger-required"
                                >*</span
                            ></label
                        >
                        <input
                            type="datetime-local"
                            formControlName="applicationDate"
                            class="form-control"
                        />
                        <div
                            *ngIf="
                                medication.get('applicationDate').invalid &&
                                medication.get('applicationDate').touched
                            "
                            class="text-danger"
                        >
                            Please select application date.
                        </div>
                    </div>

                    <!-- Notes Input -->
                    <div class="col-md-6 formGroup mb-3">
                        <label>Notes</label>
                        <textarea
                            formControlName="notes"
                            class="form-control"
                            rows="2"
                            placeholder="Optional"
                        ></textarea>
                    </div>
                </div>

                <!-- Remove Button -->
                <div class="row">
                    <div class="col-md-12 text-right">
                        <button
                            type="button"
                            class="btn btn-danger btn-sm"
                            (click)="removeMedication(i)"
                            [disabled]="medications.length <= 1"
                            title="Remove this medication entry"
                        >
                            <i class="fas fa-trash-alt"></i>
                            Delete
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12 text-right mt-1">
                <button
                    type="button"
                    class="btn-action"
                    (click)="addMedication()"
                >
                    <span class="vaccine-plus"
                        ><i class="fas fa-plus"></i
                    ></span>
                    Add Medication program
                </button>
            </div>
            <div class="col-md-12 text-center mt-5">
                <!-- <button type="submit">Save</button> -->
                <button
                    class="btn btn-action-primary"
                    type="submit"
                    [disabled]="isLoading$ | async"
                >
                    <span *ngIf="!isAuthLoading">Submit</span>
                    <span *ngIf="isAuthLoading">Submitting...</span>
                </button>
                <img
                    *ngIf="isLoading$ | async"
                    src="assets/img/loader.gif"
                    alt="Loading..."
                    class="loader-image mt-2"
                />
            </div>
        </div>
        <!-- Add Medication Program Button -->
    </form>
</div>
